import { ADMIN_PAGES_KEYS } from '../../../../../../../i18n/constants/keys';
import { JobPostConfigStepId } from '../interfaces';

export const JOB_POST_CONFIG_STEPS: Record<string, JobPostConfigStepId> = {
  SETTINGS: 'settings',
  VIDEO: 'video',
  PREQUAL: 'prequal',
  CCA: 'cca',
} as const;

export const STEP_METADATA: Record<
  JobPostConfigStepId,
  {
    stepNumber: number;
    titleKey?: string;
    fallbackTitle: string;
    description: string;
  }
> = {
  settings: {
    stepNumber: 1,
    titleKey: ADMIN_PAGES_KEYS.jobOpenings.jobPost.tabs.settings,
    fallbackTitle: 'Job Post Settings',
    description: 'Configure dates, job title, location, working arrangement, etc.',
  },
  video: {
    stepNumber: 2,
    titleKey: ADMIN_PAGES_KEYS.jobOpenings.jobPost.video.heading,
    fallbackTitle: 'Video Message',
    description: 'Provide an introductory video message greeting to prospective applicants.',
  },
  prequal: {
    stepNumber: 3,
    titleKey: ADMIN_PAGES_KEYS.jobOpenings.jobPost.preQualifying.heading,
    fallbackTitle: 'Pre-Qualifying Questions',
    description: 'Define qualifying and screening questions for applicants.',
  },
  cca: {
    stepNumber: 4,
    fallbackTitle: 'Candidate Competency Assessment (CCA)',
    description: 'Assess applicant competencies with automated benchmark tests.',
  },
};

export const CARD_TRANSITION_STYLES = {
  transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
};
